import { AnimatePresence } from "framer-motion";
import { Route, Routes, useLocation, useOutlet } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { DashboardShell } from "@/components/layout/DashboardShell";
import { RouteTransition } from "@/components/layout/PageTransition";
import { HomePage } from "@/routes/HomePage";
import { CarsPage } from "@/routes/CarsPage";
import { CarDetailPage } from "@/routes/CarDetailPage";
import { OptionSetDetailPage } from "@/routes/OptionSetDetailPage";
import { OptionSetsPage } from "@/routes/OptionSetsPage";
import { GasStationBrandDetailPage } from "@/routes/GasStationBrandDetailPage";
import { GasStationsPage } from "@/routes/GasStationsPage";
import { GasStationDetailPage } from "@/routes/GasStationDetailPage";
import { UserDetailPage } from "@/routes/UserDetailPage";
import { UsersPage } from "@/routes/UsersPage";
import { FuelActivityPage } from "@/routes/FuelActivityPage";
import { UserFuelActivityPage } from "@/routes/UserFuelActivityPage";
import { FuelSpendYearsPage } from "@/routes/FuelSpendYearsPage";
import { FuelSpendYearPage } from "@/routes/FuelSpendYearPage";
import { FuelSpendMonthPage } from "@/routes/FuelSpendMonthPage";
import { UserFuelSpendYearsPage } from "@/routes/UserFuelSpendYearsPage";
import { UserFuelSpendYearPage } from "@/routes/UserFuelSpendYearPage";
import { UserFuelSpendMonthPage } from "@/routes/UserFuelSpendMonthPage";
import { BusinessesPage } from "@/routes/BusinessesPage";
import { ConnectedServicesPage } from "@/routes/ConnectedServicesPage";
import { BusinessDetailPage } from "@/routes/BusinessDetailPage";
import { NotFoundPage } from "@/routes/NotFoundPage";
import { LoginPage } from "@/routes/LoginPage";

function DashboardLayout() {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <DashboardShell>
      <AnimatePresence mode="wait" initial={false}>
        <RouteTransition key={location.pathname}>{outlet}</RouteTransition>
      </AnimatePresence>
    </DashboardShell>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/cars" element={<CarsPage />} />
          <Route path="/cars/:id" element={<CarDetailPage />} />
          <Route path="/option-sets" element={<OptionSetsPage />} />
          <Route path="/option-sets/:id" element={<OptionSetDetailPage />} />
          <Route path="/gas-stations" element={<GasStationsPage />} />
          <Route path="/fuel-activity" element={<FuelActivityPage />} />
          <Route path="/fuel-activity/spend" element={<FuelSpendYearsPage />} />
          <Route path="/fuel-activity/spend/:year/:month" element={<FuelSpendMonthPage />} />
          <Route path="/fuel-activity/spend/:year" element={<FuelSpendYearPage />} />
          <Route path="/fuel-activity/users/:userId/spend" element={<UserFuelSpendYearsPage />} />
          <Route path="/fuel-activity/users/:userId/spend/:year/:month" element={<UserFuelSpendMonthPage />} />
          <Route path="/fuel-activity/users/:userId/spend/:year" element={<UserFuelSpendYearPage />} />
          <Route path="/fuel-activity/users/:userId" element={<UserFuelActivityPage />} />
          <Route path="/gas-station-brands/:id" element={<GasStationBrandDetailPage />} />
          <Route path="/gas-stations/:id" element={<GasStationDetailPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/:id" element={<UserDetailPage />} />
          <Route path="/businesses" element={<BusinessesPage />} />
          <Route path="/businesses/connected-services" element={<ConnectedServicesPage />} />
          <Route path="/businesses/:id" element={<BusinessDetailPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
